import { themeGet, themeGetColor } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Icon = styled.div `
  display: flex;
  transform: translateX(0%);
  transition: all 275ms cubic-bezier(0, 1.13, 0.4, 1.33);

  [data-icon='falcon'] {
    color: ${themeGet('colors.gray.200')};
    transition: inherit;
  }
`;
export const ListItem = styled.button `
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  padding: ${themeGet('spacing.md')};
  gap: ${themeGet('spacing.md')};
  list-style: none;

  border-radius: ${themeGet('borderRadius.md')};

  transition: all 0.2s ease-in-out;

  &:not(:disabled) {
    cursor: pointer;
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }

  &:hover:not(:disabled) {
    background-color: ${themeGetColor('gray.50')};

    ${Icon} {
      transform: translateX(50%);

      [data-icon='falcon'] {
        color: ${themeGet('colors.primary.500')};
      }
    }
  }
`;
export const AlignRight = styled.div `
  display: flex;
  align-items: center;
  gap: ${themeGet('spacing.xl')};
  margin-left: auto;
  margin-right: ${themeGet('spacing.lg')};
`;
